import { IResponseRegisteredAppInfo } from '@models/manager/service/serviceModel';
import { axiosInstance } from '@utils/axios/axiosInstance';
import { getHttpResponseResult } from '@utils/axios/httpResponseHelper';

// competitorsAppInfo(competitorsAppList) 에 1개의 app 을 추가할때 함수
// (이건 createAsyncThunk 가 아닌 일반 요청 함수임)
export const fetchUpdateCompetitorApp = async (params: {
  // userId: string;
  // myAppId: string;
  providerType: string;
  appSeq: string | number;
  addCompetitorApps: IResponseRegisteredAppInfo[];
  deleteCompetitorApps: IResponseRegisteredAppInfo[];
}) => {
  try {
    const response = await axiosInstance.post('/app/competitor', params);
    console.log('response: ', response);
    const { success, data } = getHttpResponseResult<{ result: boolean; message: string }>(response);
    if (success) {
      return data;
    } else {
      return {
        result: false,
        message: '',
      };
    }
  } catch (error) {
    console.log('error: ', error);
    return {
      result: false,
      message: error.message,
    };
  }
};
